import { render, staticRenderFns } from "./hqStuHealthQuestion.vue?vue&type=template&id=33e6458a&scoped=true"
import script from "./hqStuHealthQuestion.vue?vue&type=script&lang=js"
export * from "./hqStuHealthQuestion.vue?vue&type=script&lang=js"
import style0 from "./hqStuHealthQuestion.vue?vue&type=style&index=0&id=33e6458a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6458a",
  null
  
)

export default component.exports